import { render, staticRenderFns } from "./EditPatient.vue?vue&type=template&id=3a1a2dec&scoped=true&"
import script from "./EditPatient.vue?vue&type=script&lang=ts&"
export * from "./EditPatient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a2dec",
  null
  
)

export default component.exports